import { render, staticRenderFns } from "./MultiEventsChart.vue?vue&type=template&id=2bf71f4e"
import script from "./MultiEventsChart.vue?vue&type=script&lang=js"
export * from "./MultiEventsChart.vue?vue&type=script&lang=js"
import style0 from "./MultiEventsChart.vue?vue&type=style&index=0&id=2bf71f4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports